import { IFluxStandardAction } from "@common";

export enum NavigationActions {
  "NAVIGATE_TO" = "@navigation/goto"
}

export interface INavigateAction extends IFluxStandardAction<{ path: string }> {
  type: NavigationActions.NAVIGATE_TO;
}

export type NavigationActionTypes = INavigateAction;

export const navigateTo = (path: string): INavigateAction => ({
  type: NavigationActions.NAVIGATE_TO,
  payload: { path }
});
